import { render, staticRenderFns } from "./AccordionItemResearch.vue?vue&type=template&id=b6be7132&scoped=true"
import script from "./AccordionItemResearch.vue?vue&type=script&lang=js"
export * from "./AccordionItemResearch.vue?vue&type=script&lang=js"
import style0 from "./AccordionItemResearch.vue?vue&type=style&index=0&id=b6be7132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6be7132",
  null
  
)

export default component.exports